import React from 'react'
import styled from 'styled-components'
import { Grid as KendoGrid, GridColumn as Column, GridToolbar } from '@progress/kendo-react-grid'
import { Button } from '@material-ui/core'
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined'
import { Field } from '@progress/kendo-react-form'
import { Input } from '@progress/kendo-react-inputs'

const textInputCell = (props) => {
    return (
        <td>
            <StyledField
                component={Input}
                name={`projectSuppliers[${props.dataIndex}].${props.field}`}
            />
        </td>
    )
}

const currencyCell = (GridCellProps) => {
    const { dataIndex, field } = GridCellProps
    return (
        <td>
            <CurrencyField
                component={Input}
                name={`projectSuppliers[${dataIndex}].${field}`}
            />
        </td>
    )
}

const commandCell = (onRemove) => (props) => {
    const onClick = React.useCallback(
        (e) => {
            e.preventDefault()
            onRemove(props)
        },
        [onRemove]
    )
    return (
        <td>
            <DeleteOutlinedIcon onClick={onClick} style={{cursor: 'pointer'}} />
        </td>
    )
}

export default (fieldArrayRenderProps) => {
    const { validationMessage, visited } = fieldArrayRenderProps
    const onAdd = React.useCallback(
        (e) => {
            e.preventDefault()
            fieldArrayRenderProps.onPush({
                value: {
                    id: '',
                    supplierName: '',
                    supplierService: '',
                    supplierCost: '0,00 €',
                    sapOrderNumber: ''
                }
            })
        },
        [fieldArrayRenderProps.onUnshift]
    )
    const onRemove = React.useCallback(
        (cellProps) => fieldArrayRenderProps.onRemove({ index: cellProps.dataIndex }),
        [fieldArrayRenderProps.onRemove]
    )

    return <div>
        {
            visited && validationMessage &&
            (<Error>{validationMessage}</Error>)
        }
        <KendoGrid data={fieldArrayRenderProps.value}>
            <GridToolbar>
                <Button title="Hinzufügen" className="k-button k-primary" onClick={onAdd}>
                    Hinzufügen
                </Button>
            </GridToolbar>
            <Column field="supplierName" width="400px" title="Dienstleister" cell={textInputCell}/>
            <Column field="supplierService" title="Beschreibung" cell={textInputCell}/>
            <Column field="supplierCost" width="200px" title="Kosten" cell={currencyCell}/>
            <Column field="sapOrderNumber" width="250px" title="SAP Bestellnummer" cell={textInputCell}/>
            <Column cell={commandCell(onRemove)} width="70px"/>
        </KendoGrid>
    </div>
}

const StyledField = styled(Field)`
    width: 100%;
`
const CurrencyField = styled(StyledField)`
    text-align: right;
`



// WEBPACK FOOTER //
// ./src/components/dialog/ProjectSuppliersForm.js